var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-img',{attrs:{"contain":"","src":require("../assets/no_access.png"),"height":"200","width":"200"}})],1),_c('v-row',{attrs:{"justify":"center"}},[_c('strong',[_vm._v("No Previlages given at the moment")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }